import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=1f2fc886&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2fc886",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f2fc886')) {
      api.createRecord('1f2fc886', component.options)
    } else {
      api.reload('1f2fc886', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=1f2fc886&scoped=true&", function () {
      api.rerender('1f2fc886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b7mPG6zwIz4P/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports